import { Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './shared/guards/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  {
    path: 'privacy-policy',
    loadComponent: () =>
      import('./privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent),
  },
  {
    path: 'sign-up',
    loadComponent: () => import('./sign-up/sign-up.component').then(m => m.SignUpComponent),
  },
  {
    path: 'create-implementer',
    loadComponent: () =>
      import('./create-implementer/create-implementer.component').then(
        m => m.CreateImplementerComponent,
      ),
  },
  {
    path: 'create-user',
    loadComponent: () =>
      import('./create-user/create-user.component').then(m => m.CreateUserComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'implementer/:implementerId/contact-details',
    loadComponent: () =>
      import('./implementer-contact-details/implementer-contact-details.component').then(
        m => m.ImplementerContactDetailsComponent,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'implementer/:implementerId/info',
    loadComponent: () =>
      import('./implementer-info/implementer-info.component').then(m => m.ImplementerInfoComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'implementer/:implementerId/services',
    loadComponent: () =>
      import('./implementer-services/implementer-services.component').then(
        m => m.ImplementerServicesComponent,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'implementer/:implementerId/impact',
    loadComponent: () =>
      import('./implementer-impact/implementer-impact.component').then(
        m => m.ImplementerImpactComponent,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'implementer/:implementerId/document-upload',
    loadComponent: () =>
      import('./implementer-document-upload/implementer-document-upload.component').then(
        m => m.ImplementerDocumentUploadComponent,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'implementer/:implementerId/registration-complete',
    loadComponent: () =>
      import(
        './implementer-registration-complete/implementer-registration-complete.component'
      ).then(m => m.ImplementerRegistrationCompleteComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'implementer-welcome',
    loadComponent: () =>
      import('./implementer-welcome/implementer-welcome.component').then(
        m => m.ImplementerWelcomeComponent,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'implementer/:implementerId/already-registered',
    loadComponent: () =>
      import('./implementer-already-registered/implementer-already-registered.component').then(
        m => m.ImplementerAlreadyRegisteredComponent,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'implementers',
    loadComponent: () =>
      import('./implementers/implementers.component').then(m => m.ImplementersComponent),
    canActivate: [AuthGuard],
    data: { layoutClass: 'outer-scroll', roles: ['Vanhu.Admin'] },
  },
  {
    path: 'implementers/map',
    loadComponent: () =>
      import('./implementer-map/implementer-map.component').then(m => m.ImplementerMapComponent),
    canActivate: [AuthGuard],
    data: { roles: ['Vanhu.Admin'] },
  },
  {
    path: 'forbidden',
    loadComponent: () => import('./forbidden/forbidden.component').then(m => m.ForbiddenComponent),
  },
  {
    path: '**',
    loadComponent: () => import('./not-found/not-found.component').then(m => m.NotFoundComponent),
  },
];
